import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import objectValues from '@adsk/bim360-matrix-react-helpers/es/objectValues';
import { ENVS, REGIONS } from '@adsk/bim360-matrix-react-helpers/es/consts';
import {
  CONTEXT_NAMES,
  getOrCreateGlobalContext
} from '@adsk/bim360-matrix-react-helpers/es/globalContexts';
import { ENV_CONFIGS } from '../helpers/envConsts';

const EnvContext = getOrCreateGlobalContext(CONTEXT_NAMES.EnvContext);

export const EnvProvider = ({ region, env, children }) => {
  const memoizedValue = useMemo(() => ({ region, env }), [region, env]);
  return <EnvContext.Provider value={memoizedValue}>{children}</EnvContext.Provider>;
};

EnvProvider.propTypes = {
  env: PropTypes.oneOf(objectValues(ENVS)).isRequired,
  region: PropTypes.oneOf(objectValues(REGIONS)).isRequired,
  children: PropTypes.node.isRequired
};

export const useEnv = () => useContext(EnvContext);

export const useEnvConfig = key => {
  const { env, region } = useEnv();
  if (ENV_CONFIGS[region] && ENV_CONFIGS[region][env] && ENV_CONFIGS[region][env][key]) {
    return ENV_CONFIGS[region][env][key];
  } else {
    throw new Error(`Cannot find env config for env: ${env}, region: ${region} and key: ${key}`);
  }
};

export default EnvContext;
